import React from 'react';
import styled from 'styled-components';

interface Props {
  onClick: () => void;
}

const BurgerButtonClose = ({ onClick }: Props) => {
  return (
    <CloseButton onClick={onClick}>
      <span></span>
      <span></span>
    </CloseButton>
  );
};

const CloseButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  position: relative;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #333;
    border-radius: 2px;
  }
  span:nth-child(1) {
    rotate: 45deg;
  }
  span:nth-child(2) {
    rotate: -45deg;
  }
`;
export default BurgerButtonClose;
